module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "gaming-logotype.6d52ed5f.svg";